// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"304": "rich-text-editor","705": "placeholder-editor","950": "rich-editor",}[chunkId] || chunkId) + "." + {"127": "9180cea82027a658","251": "309ec7540e16536b","304": "d6ec219043728b65","313": "3a43948ae332e466","479": "8ded3f4dc07fd4fa","597": "67c8015c3a773ec3","705": "40b5827bbb4cfb60","950": "e10e58cfab0a0ef7",}[chunkId] + ".js"
}